import { badgeTemplateClassifierSchema } from '../../../../backend/config/classifiers/badge-template-classifier/types';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const badgeEntityName = 'badge';
export const badgeTemplateClassifierSnapshotSchema = z.object({
    id: z.string().uuid(),
    data: badgeTemplateClassifierSchema,
});
export const badgeSchema = z.object({
    name: z.string(),
    description: z.string().optional(),
    expirationIntervalMonths: z.number().positive(),
    templateSnapshot: badgeTemplateClassifierSnapshotSchema,
    formSettings: z.any(),
    organizationIds: z.string().uuid().array().optional(),
});
export const badgeColumns = defineColumns({
    name: { type: 'string-required', index: true },
    description: { type: 'string' },
    expirationIntervalMonths: { type: 'number' },
    organizationIds: { type: 'string-array' },
});
